<template>
    <div>
        <v-card-title>
            Content
            <v-btn small dark color="green" class="mr-4 ml-4 button-style" elevation="0" @click="addContentDialog = true">Add Content</v-btn>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn small dark color="#5D337C" class="mr-4 button-style" elevation="0">Nothing Mode</v-btn>
            <v-text-field outlined v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table multi-sort dense :sort-by.sync="sortBy" :sort-desc="[false, false]" :headers="headers" :items="offers" :options="options" :search="search" :loading="loading" loading-text="Getting the content list... Don't be impatient...">
            <template v-slot:item.logoDownloadUrl="{ item }">
                <v-img width="70" class="my-3" :src="item.logoDownloadUrl"></v-img>
            </template>
            <template v-slot:item.bannerDownloadUrl="{ item }">
                <v-img width="160" class="my-3" :src="item.bannerDownloadUrl"></v-img>
            </template>
            <template v-slot:item.name="{ item }">
                <div style="width: 100px" class="my-3">{{item.name}}</div>
            </template>
            <template v-slot:item.description="{ item }">
                <div class="my-3" v-html="item.description"></div>
            </template>
        </v-data-table>
        <v-dialog v-model="addContentDialog" max-width="1300px">
            <AddContent @clicked="addContentDialog = false" />
        </v-dialog>
    </div>
</template>
<script>
import moment from 'moment'
import AddContent from '../components/AddContent.vue'
export default {
    name: 'Content',
    components: {
        AddContent
    },
    data(){
        return {
            addContentDialog: false,
            search: '',
            loading: false,
            sortBy: ['name'],
            headers: [
                { text: 'Offer', value: 'name', 'sortable?': true },
                { text: 'Logo', value: 'logoDownloadUrl', 'sortable?': true },
                { text: 'Banner', value: 'bannerDownloadUrl', 'sortable?': true },
                { text: 'Description', value: 'description', 'sortable?': true },
            ],
            offers: [],
            options:{
                itemsPerPage: 100
            }
        }
    },
    methods: {
    },
    mounted(){
        document.title = "Vaboo Platform Content"
        this.loading = true
        firebase.firestore().collection('content').doc('offers').collection('basic-offers').onSnapshot(snapshot => {
            this.offers = []
            snapshot.forEach(doc => {
                var offer = doc.data()
                this.offers.push(offer)
            })
            this.loading = false
        })
    }
}
</script>

<style>

</style>